module.exports = __webpack_public_path__ + "img/25.8683b99a.png";